import React from 'react'
import { SVGIconProps } from '../types'
const SvgCelebration = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="m2 22 14-5-9-9zm12.53-9.47 5.59-5.59a1.25 1.25 0 0 1 1.77 0l.59.59 1.06-1.06-.59-.59a2.76 2.76 0 0 0-3.89 0l-5.59 5.59zm-4.47-5.65-.59.59 1.06 1.06.59-.59a2.76 2.76 0 0 0 0-3.89l-.59-.59-1.06 1.07.59.59c.48.48.48 1.28 0 1.76m7 5-1.59 1.59 1.06 1.06 1.59-1.59a1.25 1.25 0 0 1 1.77 0l1.61 1.61 1.06-1.06-1.61-1.61a2.76 2.76 0 0 0-3.89 0m-2-6-3.59 3.59 1.06 1.06 3.59-3.59a2.76 2.76 0 0 0 0-3.89l-1.59-1.59-1.06 1.06 1.59 1.59c.48.49.48 1.29 0 1.77" />
  </svg>
)
export default SvgCelebration
